export const PropertyFormatIdentifier = {
  text: "text",
  multitext: "multitext",
  list: "list",
  integer: "integer",
  double: "double",
  currency: "currency",
  percentage: "percentage",
  boolean: "boolean"
};

export const PropertyFormatNames = {
  text: "Single-line text",
  multitext: "Multi-line text",
  boolean: "Yes/No",
  list: "List of options",
  integer: "Integer number",
  double: "Decimal number",
  currency: "Currency",
  percentage: "Percentage"
};

const PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ALL = "All children ticked";
const PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ANY = "Any child ticked";
const PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_SUM = "Sum";
const PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_AVG = "Average";
const PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MAX = "Maximum";
const PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MIN = "Minimum";
const PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_AVG = "Average Percentage";
const PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_WEIGHTED = "Weighted Percentage";

export const PropertyAutoCalculateTypes = {
  PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ALL,
  PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ANY,
  PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_SUM,
  PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_AVG,
  PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MAX,
  PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MIN,
  PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_AVG,
  PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_WEIGHTED
};

export const PropertyFormatAutoCalculateTypeOptions = {
  boolean: [PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ALL, PROPERTY_AUTO_CALCULATE_TYPE_BOOLEAN_ANY],
  number: [
    PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_SUM,
    PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_AVG,
    PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MAX,
    PROPERTY_AUTO_CALCULATE_TYPE_NUMBER_MIN
  ],
  percentage: [PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_AVG, PROPERTY_AUTO_CALCULATE_TYPE_PERCENTAGE_WEIGHTED]
};

export const PropertyFormatAutoCalculateTypes = {
  boolean: PropertyFormatAutoCalculateTypeOptions.boolean,
  integer: PropertyFormatAutoCalculateTypeOptions.number,
  double: PropertyFormatAutoCalculateTypeOptions.number,
  currency: PropertyFormatAutoCalculateTypeOptions.number,
  percentage: PropertyFormatAutoCalculateTypeOptions.percentage
};

const createFormat = id => {
  return {
    identifier: id,
    name: PropertyFormatNames[id]
  };
};

export default [
  createFormat(PropertyFormatIdentifier.text),
  createFormat(PropertyFormatIdentifier.multitext),
  createFormat(PropertyFormatIdentifier.list),
  createFormat(PropertyFormatIdentifier.boolean),
  createFormat(PropertyFormatIdentifier.percentage),
  createFormat(PropertyFormatIdentifier.integer),
  createFormat(PropertyFormatIdentifier.double),
  createFormat(PropertyFormatIdentifier.currency)
];
